// extracted by mini-css-extract-plugin
export default {"main":"ErrorPage_main","textBlock":"ErrorPage_textBlock"};